import { Drawer, Layout } from "antd";
import { ReactNode, Suspense } from "react";
import { useAppSelector } from "../app/store";
import SidebarContent from "../components/common/sidebar/SidebarContent";
import SidebarItems from "../components/common/sidebar/SidebarItems";
import Loader from "../components/ui/Loader";
import { useGetEmployeeDetailsQuery } from "../features/employee/employeeApi";
import useSidebar from "../hooks/useSidebar";
import AppLayout from "./AppLayout";

export interface SidebarLayoutProps {
  children?: ReactNode;
  appTitle?: string;
  title?: string;
  contentClass?: string;
  tabList?: {
    label: string;
    link: string;
    redirect?: string;
    disabled?: boolean;
  }[];
}

export default function SidebarLayout({
  children,
  title,
  appTitle,
  tabList,
  contentClass,
}: SidebarLayoutProps) {
  const {
    collapsed,
    openSidebar,
    openMenuKeys,
    handleOpenMenu,
    handleCollapsed,
    handleShowSidebar,
    handleCloseSidebar,
  } = useSidebar();
  const { authInfo } = useAppSelector((state) => state.auth);
  const { data: userData, isLoading: userLoading } = useGetEmployeeDetailsQuery(
    authInfo?.id?.toString() || "",
    {
      skip: !authInfo?.id,
    }
  );
  return (
    <div>
      <Layout>
        <div className="lg:hidden ">
          <Drawer
            placement="left"
            closable={false}
            onClose={handleCloseSidebar}
            open={openSidebar}
            key="left"
            contentWrapperStyle={{ width: "auto" }}
            bodyStyle={{ padding: 0, overflowY: "hidden" }}
            // styles={{
            //   body: { padding: 0, overflowY: "hidden" },
            //   wrapper: { width: "auto" },
            // }}
          >
            <SidebarItems
              collapsed={false}
              openMenuKeys={openMenuKeys}
              handleOpenMenu={handleOpenMenu}
              isMobile
            />
          </Drawer>
        </div>
        <div className="hidden lg:block border-r border-extra-light">
          <SidebarItems
            collapsed={collapsed}
            openMenuKeys={openMenuKeys}
            handleOpenMenu={handleOpenMenu}
          />
        </div>

        {/* Sidebar content is main children component, where show children data. This component contains Header items like: Profile and Notification  */}
        <AppLayout
          title={appTitle || title}
          className={`w-full ${
            collapsed ? "lg:w-[calc(100vw-80px)]" : "lg:w-[calc(100vw-321px)]"
          }`}
        >
          <SidebarContent
            collapsed={collapsed}
            handleCollapsed={handleCollapsed}
            handleShowSidebar={handleShowSidebar}
            title={title}
            tabList={tabList}
            data={userData}
            isLoading={userLoading}
            contentClass={contentClass}
          >
            <Suspense fallback={<Loader />}>{children}</Suspense>
          </SidebarContent>
        </AppLayout>
      </Layout>
    </div>
  );
}
